import React from 'react';

/**
 * Stable full-viewport blur layer for SRE drawers.
 * Memoized so stream/timer re-renders of the parent Dialog do not touch this DOM
 * node — Chromium otherwise drops backdrop-filter when the layer is reconciled
 * or opacity-animated.
 */
const SreWorkbenchBlur = React.memo(function SreWorkbenchBlur() {
  return <div className="sre-wb-backdrop-blur" aria-hidden />;
});

export default SreWorkbenchBlur;
